// Is a given variable undefined?
export default function isUndefined(obj) {
  return obj === void 0;
}



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isUndefined.js
// module id = 295
// module chunks = 8